module.exports = __webpack_public_path__ + "assets/img/wlqzg_djs_bg.d9f35620.jpg";